import { initialState } from './state';

const mutations = {

  SET_CLEAR_MEDICALORDERS(state) {
    Object.assign(state, initialState);
  },

  SET_UPLOADED_MEDICAL_ORDERS(state, medicalOrders) {
    state.data.uploadedMedicalOrders = medicalOrders;
  },

  SET_SEND_TO_ANALYZE(state, analyze) {
    state.data.hasSentToAnalyze = analyze;
  },

};

export default mutations;
